import { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { PlusIcon } from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableDepartmentTag,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import Tooltip from "../../../../component/ui/tooltip";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import CarQuickView from "../../popup/car";
import CarModal from "../../../../component/popup/add-update-car";
import UnassignCar from "../../../../component/popup/unassign-car";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import StatusChip from "../../../../component/ui/chip/status";
import { TitleHeading } from "../../../../component/ui/layout";
import { AlphabetIcon, CarIcon, CategoryIcon, PriceIcon, RegistrationIcon, YearIcon } from "../../../../component/icons/filter-icons";

const FleetCarList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [vendors, setVendors] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [unassignModal, setUnassignModal] = useState(false);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
    getVendors();
  }, []);

  const getData = async ({ filter = filterReturn, page = "" }) => {
    if (!page) {
      setIsLoading(true);
    }
    let extraUrl = `?page=${page}`;
    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.selectedOpt == "between") {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value[0]}_${filter[i]?.value[1]}`;
      } else {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
      }
    }
    try {
      const res = await apiCall({
        method: "get",
        url: `all-car-fleet${extraUrl}`,
      });
      if (page) {
        setList((prev) => [...prev, ...res.data]);
      } else {
        setList(res.data);
      }
      setTableHeaders(res?.headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const getVendors = async () => {
    try {
      let apiRes = await apiCall({
        method: "get",
        url: "get-fleet-car-van-dropdown?search_by_key_dd=allFleetVendor",
      });
      setVendors(apiRes?.getFleetCarVanDropdown);
    } catch (error) {
      console.log("Error", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getData({});
    setCurrentData({});
    setAddModal(false);
    setUnassignModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const filterModalData = [
    {
      name: "search_by_user_name",
      label: "Employee Name",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
      Icon: AlphabetIcon
    },
    {
      name: "search_by_car_name",
      label: "Car Name",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
      Icon: CarIcon
    },
    {
      name: "search_by_car_model",
      label: "Car Model",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
      Icon: YearIcon
    },
    {
      name: "search_by_car_variant",
      label: "Car Variant",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
      Icon: CategoryIcon
    },
    {
      name: "search_by_car_registraion",
      label: "Registration Number",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
      Icon: RegistrationIcon
    },
    {
      name: "search_by_rent",
      label: "Rent",
      options: ["is", "between"],
      selectedOpt: "between",
      value: "",
      type: "text",
      Icon: PriceIcon
    },
  ];

  const viewDetail = (ele) => {
    setIsShowModal(true);
    setCurrentData(ele);
  };

  const editDetail = (ele) => {
    setCurrentData(ele);
    setAddModal(true);
  };

  const tableRef = useRef(null);
  const masterCheckboxRef = useRef();

  const handleToggleAll = () => {
    const allIds = lists.map((ele) => {
      if (ele?.is_assigned == 1) {
        return ele?.id;
      }
    });
    // const cleaned = allIds.filter(v => (v !== undefined && v !== null));
    // console.log(cleaned);
    const isAllChecked = selectedIds?.length === allIds?.length;
    setSelectedIds(isAllChecked ? [] : allIds);
  };

  const handleToggleOne = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
    );
  };

  return (
    <>
      <div className={Style.leaveMainPage}>
        <div className={Style.report_table__header}>
          <span className={Style.report_table__title}>
            <TitleHeading title={`Car List`} />
            
            {selectedIds?.length ? (
              <div
                className="inline-flex cursor-pointer items-center gap-1.5 rounded-xl border border-solid border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
                onClick={() => {
                  setUnassignModal(true);
                }}
              >
                Unassign
              </div>
            ) : null}
          </span>

          <div className={Style.bpfl_action}>
            <div
              className={Style.bpfl_action}
              onClick={() => {
                setAddModal(true);
              }}
            >
              <Tooltip
                content={"Add Car"}
                position={"left center"}
                className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
              >
                <div className={Style.icon}>
                  <PlusIcon size={"1em"} />
                </div>
              </Tooltip>
            </div>
            <Tooltip
              className={Style.bpfl_actionItems}
              content={"Table Filter"}
              position={"left center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${
                  filterReturn?.length ? Style.active : null
                }`}
                onClick={() => {
                  setShowModalFilterTable(true);
                }}
              >
                <div className={Style.icon}>
                  <FilterFunnel01Icon />
                </div>
              </div>
            </Tooltip>
            <div className={`${Style.bpfl_action}`}>
              <Tooltip
                className={`${Style.bpfl_actionItems}`}
                content={"Customize Table"}
                position={"left center"}
              >
                <div
                  className={`${Style.bpfl_actionBtn}`}
                  onClick={() => {
                    setShowModalCustomizeTabs(true);
                  }}
                >
                  <div className={Style.icon}>
                    <LayoutTopIcon />
                  </div>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>

        <div className={Style.LeaveBody}>
          {isLoading ? (
            <InnerLoader />
          ) : !lists?.length ? (
            <DataNotFound title={"lists"} />
          ) : (
            <>
              <TableCard ref={tableRef}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell header sticky>
                        <div className="flex gap-4 items-center">
                          <div className={Style.tableCheckBox}>
                            <label className={Style.custom_checkbox}>
                              <input
                                type="checkbox"
                                ref={masterCheckboxRef}
                                className={Style.customCheckbox}
                                checked={selectedIds?.length == lists?.length}
                                disabled={
                                  lists?.filter((ele) => ele?.is_assigned != 0)
                                    ?.length == 0
                                }
                                onChange={handleToggleAll}
                              />
                              <span className={Style.checkmark}></span>
                            </label>
                          </div>
                          <span>Name</span>
                        </div>
                      </TableCell>
                      {tableHeaders?.map((eachHead, index) =>
                        eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                          <TableCell header key={index}>
                            <TableHeaderWrap>
                              <span>{eachHead?.value}</span>
                            </TableHeaderWrap>
                          </TableCell>
                        ) : null
                      )}

                      {/* <TableCell header><TableHeaderWrap><span>Time In</span></TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap><span>Time Out</span></TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap><span>Working Hour</span></TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap><span>Status</span></TableHeaderWrap></TableCell> */}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {lists?.map((eachList, index) => {
                      return (
                        <TableRow key={`${index}`}>
                          <TableCell sticky>
                            <div className={`${Style.tableActionArea} !gap-4`}>
                              <div className="flex gap-2 items-center">
                                <div className={Style.tableCheckBox}>
                                  {
                                    <label className={Style.custom_checkbox}>
                                      <input
                                        type="checkbox"
                                        className={`${Style.customCheckbox} ${
                                          eachList?.is_assigned == 0
                                            ? "disable"
                                            : ""
                                        }`}
                                        checked={selectedIds?.includes(
                                          eachList?.id
                                        )}
                                        onChange={() =>
                                          handleToggleOne(eachList?.id)
                                        }
                                        disabled={eachList?.is_assigned == 0}
                                      />
                                      <span className={Style.checkmark}></span>
                                    </label>
                                  }
                                </div>

                                {/* <div className="flex items-center gap-1">
                                  <div className={Style.btn} onClick={() => { viewDetail(eachList, eachList?.vehicle_type) }}>
                                    <div className={Style.icon} style={{ color: '#0284c7' }}><Eye className="h-4.5 w-4.5" /></div>
                                  </div>
                                  <div className={Style.btn} onClick={() => { editDetail(eachList) }}>
                                    <div className={Style.icon} style={{ color: '#d97706' }}><Pencil className="h-4.5 w-4.5" /></div>
                                  </div>
                                </div> */}
                                <div className="flex items-center gap-3">
                                  {eachList?.car_image ? (
                                    <img
                                      className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center"
                                      src={eachList?.car_image}
                                      alt={eachList?.car_name}
                                    />
                                  ) : (
                                    <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                      {eachList?.car_name?.split(" ")[0]
                                        ? eachList?.car_name?.split(" ")[0][0]
                                        : ""}
                                      {eachList?.car_name?.split(" ")[1]
                                        ? eachList?.car_name?.split(" ")[1][0]
                                        : ""}
                                    </div>
                                  )}
                                  <div>
                                    <div className="font-medium leading-5">
                                      {eachList?.car_name}
                                    </div>
                                    {/* <div className="text-xs text-muted-foreground">{eachList?.vendor_name}</div> */}
                                  </div>
                                </div>
                              </div>

                              <div className={Style.tableActionAreaBtnGrpup}>
                                <div
                                  className={
                                    "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                  }
                                  onClick={() => {
                                    editDetail(eachList);
                                  }}
                                >
                                  <div
                                    className={Style.icon}
                                    style={{ color: "#FF9500" }}
                                  >
                                    <NewEditIcon className="h-4.5 w-4.5" />
                                  </div>
                                </div>

                                <div
                                  className={
                                    "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                  }
                                  onClick={() => {
                                    viewDetail(
                                      eachList,
                                      eachList?.vehicle_type
                                    );
                                  }}
                                >
                                  <div
                                    className={Style.icon}
                                    style={{ color: "#007AFF" }}
                                  >
                                    <NewEyeIcon className="h-4.5 w-4.5" />
                                  </div>
                                </div>

                                {/* <Link
                                  to={`/organization/employee-directory/${ele.id}`}
                                  className={
                                    "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                  }
                                >
                                  <div
                                    className={Style.icon}
                                    style={{ color: "#34C759" }}
                                  >
                                    <NewCardIcon className="h-4.5 w-4.5" />
                                  </div>
                                </Link> */}
                              </div>
                            </div>
                          </TableCell>
                          {tableHeaders?.map((eachHead, i) =>
                            eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                              <>
                                {/* // <TableCell key={`${i}-${index}`}>{eachList[eachHead?.key] ?? "-"}</TableCell>*/}

                                {eachHead.key === "status" ? (
                                  <TableCell
                                    key={`${i}-${index}`}
                                    className={`text-center`}
                                  >
                                    {eachList[eachHead?.key] === "Active" ? (
                                      <StatusChip color="green">
                                        {eachList[eachHead?.key] || "--"}
                                      </StatusChip>
                                    ) : eachList[eachHead?.key] ===
                                      "In-Active" ? (
                                      <StatusChip color="red">
                                        {eachList[eachHead?.key] || "--"}
                                      </StatusChip>
                                    ) : (
                                      <StatusChip color="blue">
                                        {eachList[eachHead?.key] || "--"}
                                      </StatusChip>
                                    )}
                                  </TableCell>
                                ) : eachHead.key === "assigned_user_department" ? (
                                  <TableCell
                                    key={`${i}-${index}`}
                                    className={`text-center`}
                                  >
                                    <div className="text-center">
                                      {eachList?.assigned_user_department ? (
                                        <TableDepartmentTag
                                          title={eachList?.assigned_user_department}
                                        />
                                      ) : (
                                        "--"
                                      )}
                                    </div>
                                  </TableCell>
                                ) : (
                                  <TableCell key={`${i}-${index}`}>
                                    {eachList[eachHead?.key] ?? "-"}
                                  </TableCell>
                                )}
                              </>
                            ) : null
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableCard>
            </>
          )}
        </div>

        {!isLoading ? (
          <div className={Style.table_footer} style={{ alignItems: "center" }}>
            <div className={Style.table_footer_left}>
              {`showing 1 to ${lists?.length} of ${
                tablePagination?.total || lists?.length
              }`}
            </div>

            {tablePagination ? (
              <div className={Style.empDirectory_footer}>
                {tablePagination?.next_page_url ? (
                  <button
                    className={Style.loadMoreBtn}
                    onClick={() => {
                      if (btnLoader) return;
                      // setPageCount(pageCount + 1);
                      setBtnLoader(true);
                      // filterData({ page: pageCount + 1, btnCall: true });
                      getData({ page: tablePagination?.next_page_url });
                    }}
                  >
                    {btnLoader ? (
                      <InnerLoader
                        className={Style.loader}
                        textStatus={false}
                      />
                    ) : (
                      "Load More"
                    )}
                  </button>
                ) : null}
              </div>
            ) : null}

            <div
              className={`${Style.table_footer_left} ${Style.rightText}`}
            ></div>
          </div>
        ) : (
          <div className={Style.table_footer} style={{ alignItems: "center" }}>
            <div className={Style.table_footer_left}>
              <Skeleton width={"50%"} height={15} />
            </div>

            <div className={Style.empDirectory_footer}>
              <Skeleton width={"180px"} height={40} />
            </div>

            <div
              className={`${Style.table_footer_left} ${Style.rightText}`}
            ></div>
          </div>
        )}
      </div>

      {unassignModal && (
        <UnassignCar
          selectedCars={selectedIds}
          onClose={() => {
            setUnassignModal(false);
          }}
          onError={onError}
          onSubmit={(msg) => {
            setSelectedIds([]);
            onSuccess(msg);
          }}
        />
      )}

      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="all-car-fleet"
        />
      )}

      {addModal && (
        <CarModal
          vendors={vendors}
          carData={currentData}
          onClose={() => {
            setAddModal(false);
            setCurrentData({});
          }}
          onError={onError}
          onSubmit={onSuccess}
        />
      )}

      {isShowModal && (
        <CarQuickView
          onReload={() => {
            getData({});
          }}
          data={currentData}
          onClose={() => {
            setIsShowModal(false);
            setCurrentData({});
          }}
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeaders(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeaders(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="all-car-fleet"
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FleetCarList;
